import { CONSTANTS_GENERATION__slider_step as CONSTANTS_SLIDER } from '@shared/constants/CONSTANTS_GENERATION__slider_step';
import { CONSTANTS_GENERATION__value_range as CONSTANTS_RANGE } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { ENUM__t2i_adapter_type, ENUM_UTILS__t2i_adapter_type } from '@shared/dto/+model/sd/_enums/ENUM__t2i_adapter_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { MAP__fields_by_role } from '@shared/types/types';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { ENUM__field_role } from '../../../_invocations/_base/ENUM__field_role';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { FIELD__base_visible_connectable } from '../../_base/FIELD__base_connectable';
import { DECORATOR__class_serialization_tested } from '../../_primitives/_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../../_primitives/_base/DECORATOR__class_serialization_tested_for_hash';
import { DECORATOR__field_is_input } from '../../_primitives/_base/DECORATOR__field_is_input';
import { DECORATOR__field_not_linked } from '../../_primitives/_base/DECORATOR__field_not_linked';
import { FIELD_PRIMITIVE__float } from '../../_primitives/number/FIELD_PRIMITIVE__float';
import { FIELD_PRIMITIVE__string_enum } from '../../_primitives/string/FIELD_PRIMITIVE__string_enum';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '../../_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { ENUM__image_asset_category } from '../../ENUM__image_asset_category';
import { FIELD__image_asset } from '../../image/FIELD__image_asset';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD__ml_asset_t2i_adapter extends FIELD__base_visible_connectable {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_ML_ASSET_T2I_ADAPTER;

  /*
   *
   */

  static sort_by_hash(a: FIELD__ml_asset_t2i_adapter, b: FIELD__ml_asset_t2i_adapter) {
    let hash_a = a.model.get_value();
    let hash_b = b.model.get_value();

    return hash_a.localeCompare(hash_b);
  }

  /*
   * FIELDS
   */

  @FIELD_PRIMITIVE__string_enum.register_input__enum(ENUM__t2i_adapter_type.COLOR, ENUM__t2i_adapter_type, {
    field_role: '🎛️ T2I Type',
    grid2d__can_be_dimension: false,
    ui__has_component: false,
  })
  type!: FIELD_PRIMITIVE__string_enum;

  @FIELD_PRIMITIVE__string_hash_ml_asset.init_field_with_type(ENUM__ml_asset_type.T2I_ADAPTER, { field_role: ENUM__field_role.MODEL__T2I })
  model!: FIELD_PRIMITIVE__string_hash_ml_asset;

  @FIELD__image_asset.init_as_field_transform_stretch({ category: ENUM__image_asset_category.IMAGE })
  image!: FIELD__image_asset;

  //  todo: use list depends on steps
  @FIELD_PRIMITIVE__float.init_as_field(
    {
      value: 1.0,
      value_range: CONSTANTS_RANGE.WEIGHT_RANGE,
      values_allowed: CONSTANTS_RANGE.WEIGHT_ALLOWED,
      //
      slider_step: CONSTANTS_SLIDER.WEIGHT_DEFAULT,
      slider_step_values: CONSTANTS_SLIDER.WEIGHT_VALUES,
    },
    //
    { field_role: '💪 T2I Weight' },
  )
  weight!: FIELD_PRIMITIVE__float;

  @FIELD_PRIMITIVE__float.init_as_field(
    { value: 0.0, value_range: CONSTANTS_RANGE.ZERO_TO_ONE, values_allowed: CONSTANTS_RANGE.ZERO_TO_ONE },
    { field_role: '🏁 T2I Begin at %' },
  )
  step_percent_begin!: FIELD_PRIMITIVE__float;

  @FIELD_PRIMITIVE__float.init_as_field(
    { value: 1.0, value_range: CONSTANTS_RANGE.ZERO_TO_ONE, values_allowed: CONSTANTS_RANGE.ZERO_TO_ONE },
    { field_role: '🏁 T2I End at %' },
  )
  step_percent_end!: FIELD_PRIMITIVE__float;

  /*
   * PROPERTIES
   */

  field_connectable__type() {
    return ENUM__field_connectable_type.ML_ASSET__T2I_ADAPTER;
  }

  field_connectable__value(graph: DTO_GRAPH__instance): string {
    return this.meta.field_hash__value_full;
  }

  @DECORATOR__field_not_linked()
  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance) {
    if (!this.image.get_has_content()) return false;
    if (this.image.asset_original__is_single_color) return false;
    if (this.weight.get_value() == 0) return false;
    if (this.step_percent_begin.get_value() == this.step_percent_end.get_value()) return false;
    if (this.model.get_value().is_empty_hash_sha256()) return false;

    return super.has_effect_on_generation_runtime(graph);
  }

  /*
   * METHODS
   */

  post_init(): void {
    super.post_init();

    this.model.meta.field_role = '📦 T2I Model';
  }

  prepare_for_usage_in(graph: DTO_GRAPH__instance) {
    super.prepare_for_usage_in(graph);

    /*
     * STEP PERCENT
     */

    this.step_percent_begin.sync_with_field_max(this.step_percent_end);

    /*
     * IMAGE CATEGORY
     */
    let t2i_adapter_type = this.type.get_value_enum(ENUM__t2i_adapter_type);

    let valid_category = ENUM_UTILS__t2i_adapter_type.get_image_category_for(t2i_adapter_type);

    let category_was_canged = this.image.category != valid_category;

    this.image.category = valid_category;

    /*
     * IMAGE CONTENT
     */
    if (!this.image.get_has_content()) return; //no need to reset image
    // todo: mb need replace with all synced fields
    if (!category_was_canged) return; //category was not changed
    if (this.image.hash_sha256_content.is_empty_hash_sha256()) return; //no need to reset empty image

    /*
     *
     */

    this.image.image__clear();
    graph.field__replace(this.image);

    /*
     *
     */
  }

  update_fields_aliases(fields_map: MAP__fields_by_role) {
    super.update_fields_aliases(fields_map);

    let type = this.type.get_value_enum(ENUM__t2i_adapter_type);

    this.try_set_field_role(fields_map, this.weight, `🎛️ T2I "${type}" Weight`);
    this.try_set_field_role(fields_map, this.image, `🎛️ T2I "${type}" Image`);

    this.try_set_field_role(fields_map, this.step_percent_begin, `🎛️ T2I "${type}" Step Begin`);
    this.try_set_field_role(fields_map, this.step_percent_end, `🎛️ T2I "${type}" Step End`);
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  store__serialization_keys_list_white_for_hash(): string[] {
    let out: (keyof this)[] = ['type', 'model', 'image', 'weight', 'step_percent_begin', 'step_percent_end'];
    return out as string[];
  }
}
